/* eslint-disable max-len */
/* eslint-disable no-console */
import { Grid, IconButton, Menu, MenuItem, Tooltip, Box } from '@mui/material';
import React, { Dispatch, SetStateAction, useContext, useState, useMemo, useCallback } from 'react';
import { IoMdMore } from 'react-icons/io';
import { MdInfoOutline } from 'react-icons/md';
import { updateCategory } from '../../../../../../../../actions/resource_configuration';
import { deleteCategory, moveAllContent } from '../../../../../../../../actions/resource_configuration/category_management';
import { toast } from 'react-toastify';
import CategoryDeletePopup from './DeletePopup';
import { useSelector } from 'react-redux';
import { LanguageContext } from '../../../../../../../../../libs/Context';
import { catchErr } from '../../../../../../../../../libs/HelperContent';
import useContentPermissions from '../../../Reusable/ContentCards/useContentPermissions';
import useResourceHelper from '../../../Reusable/ContentCards/useResourceHelper';

interface EditCategoriesProps {
	handlePreview: React.MouseEventHandler;
	handleDeleteCategory?: React.MouseEventHandler;
	handleOpenOptions?: React.MouseEventHandler;
	handleEditCategory?: (e: React.MouseEvent<HTMLElement>) => void;
	handlemOpenplaylisttoSlider?: React.MouseEventHandler;
	handlemOpenMovetoSlider?: React.MouseEventHandler;
	handleCopyLink: (e: React.MouseEvent<HTMLElement>) => void;
	ContentCategoryType?: boolean;
	type?: string;
	StatusTxtMsg?: string;
	status?: string;
	ContentView?: any;
	category?: any;
	setCategoryData?: (data: any) => void;
	onDeleteSuccess?: () => void;
}

export const EditCategories = ({
	handlePreview,
	handleEditCategory,
	handleCopyLink,
	category,
	setCategoryData,
	onDeleteSuccess
}: EditCategoriesProps) =>
{
	const [ showDeleteConfirm, setShowDeleteConfirm ] = useState(false);
	const [ isDeleting, setIsDeleting ] = useState(false);
	const [ isConfirmed, setIsConfirmed ] = useState(false);
	const uncategorizedId = useSelector((state: any) => state.myresource?.uncategorizedId);
	// const [ anchorEl, setAnchorEl ] = useState<HTMLElement | null>(null);
	// const buttonRef = React.useRef<HTMLElement | null>(null);
	const [anchorEl, setAnchorEl] = React.useState<{ top: number; left: number } | null>(null);
	const { language } = useContext(LanguageContext);
	const { isAdminView } = useResourceHelper();
	const {
		hasEditPermission
	} = useContentPermissions();

	const hasWritePermission = useMemo(() =>
	{
		return hasEditPermission;
	}, [ hasEditPermission ]);

	const hasAnyMenuItems = useMemo(() =>
	{
		// Check if any menu items are available
		const hasEnableDisable = hasWritePermission;
		const hasShare = category?.allowShare;
		const hasEditDelete = hasWritePermission;

		return hasEnableDisable || hasShare || hasEditDelete;
	}, [ hasWritePermission, category?.allowShare ]);

	const handleMoreClick = (event: React.MouseEvent<HTMLElement>) =>
	{
		event.stopPropagation();
		// buttonRef.current = event.currentTarget;
		// setAnchorEl(event.currentTarget);

   const rect = event.currentTarget.getBoundingClientRect();
  setAnchorEl({
    top: rect.bottom,
    left: rect.left,
  });
	};

	const handleClose = (event: React.MouseEvent<HTMLElement>) =>
	{
		event.stopPropagation();
		setAnchorEl(null);
	};

	const handlePreviewClick = (event: React.MouseEvent<HTMLElement>) =>
	{
		event.stopPropagation();
		handlePreview(event);
		setAnchorEl(null);
	};

	const handleEnableDisable = (e: React.MouseEvent<HTMLElement>) =>
	{
		e.stopPropagation();
		if (!hasWritePermission)
		{
			toast.error('You do not have permission to enable/disable categories');

			return;
		}

		if (category && category._id)
		{
			updateCategory(category._id, { isEnabled: !category.isEnabled })
				.then((response) =>
				{
					console.log('Category update successful:', response);
					setAnchorEl(null); // Close the menu after successful update
					if (setCategoryData) setCategoryData(response);
				})
				.catch((error) =>
				{
					console.error('Error updating category:', error);
					catchErr(error);
				});
		}
		else
		{
			console.error('Cannot enable/disable: category or category ID is undefined');
		}
	};

	const handleCategoryDelete = async (e: React.MouseEvent<HTMLElement>) =>
	{
		e.stopPropagation();

		if (!hasWritePermission)
		{
			toast.error('You do not have permission to delete categories');

			return;
		}

		if (category?.subcategoryCount > 0)
		{
			toast.error('Category having sub-category cannot be deleted. Please delete sub-category first.');
			setShowDeleteConfirm(false);

			setAnchorEl(null); // Close the menu

			return;
		}
		setAnchorEl(null); // Close the menu

		setShowDeleteConfirm(true); // Show the confirmation dialog
	};

	// Handle confirmation checkbox change in delete popup
	const handleConfirmChange = (event: React.ChangeEvent<HTMLInputElement>) =>
	{
		event.stopPropagation();
		setIsConfirmed(event.target.checked);
	};

	// Function to handle the actual category deletion
	const handleDeleteConfirm = async (e?: any) =>
	{
		if (e) e.stopPropagation();

		if (!hasWritePermission)
		{
			toast.error('You do not have permission to delete categories');
			setShowDeleteConfirm(false);

			return;
		}

		if (!category || !category._id)
		{
			toast.error('Cannot delete: invalid category');
			setShowDeleteConfirm(false);

			return;
		}

		try
		{
			setIsDeleting(true);
			// Perform the deletion
			// if (isConfirmed)
			// {
			await moveAllContent(category._id, uncategorizedId);
			await deleteCategory(category._id);
			// }
			// else
			// {
			// 	await deleteCategory(category._id);
			// }
			toast.success('Category deleted successfully');

			// Close the dialog first
			setShowDeleteConfirm(false);

			// Immediately trigger the callback to update the category list
			if (onDeleteSuccess)
			{
				onDeleteSuccess();
			}
		}
		catch (error: any)
		{
			console.error('Error deleting category:', error.response.data.message);
			catchErr(error);
		}
		finally
		{
			setIsDeleting(false);
			setShowDeleteConfirm(false);
		}
	};

	if (!isAdminView || !hasAnyMenuItems) return null;

	return (
		<div onClick={(e) => e.stopPropagation()}>
			<Grid item>
				{hasAnyMenuItems && isAdminView && (
					<IconButton
						onClick={handleMoreClick}
						sx={{
							backgroundColor : 'white',
							'&:hover'       : {
								backgroundColor : 'white'
							},
							boxShadow : '0px 2px 4px rgba(0, 0, 0, 0.1)'
						}}
					>
						<IoMdMore fontSize='24px' color='#000'/>
					</IconButton>
				)}
				<Menu
//   anchorEl={anchorEl}
  open={Boolean(anchorEl)}
  onClose={handleClose}
anchorReference="anchorPosition"
  anchorPosition={
    anchorEl
      ? { top: anchorEl.top, left: anchorEl.left }
      : undefined
  }
  PaperProps={{
						sx : {
							bgcolor        : 'rgba(115, 115, 115, 0.6)',
							color          : '#fff',
							backdropFilter : 'blur(2px)',
							zIndex:0
						}
					}}
  transformOrigin={{
    vertical: 'top',
    horizontal: 'right',
  }}
>

					{hasWritePermission && (
						<MenuItem onClick={handleEnableDisable} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1 }}>
							<Box>{category?.isEnabled ? 'Disable' : 'Enable'}</Box>
							{category?.isEnabled &&
							<Tooltip
								title={category?.isEnabled
									? 'Disabling the category hides its content and all sub-category content from end users.'
									: 'Enable this category to make contents visible to shared users'}
								placement='right'
								arrow
							>
								<Box
									sx={{
										display        : 'flex',
										alignItems     : 'center',
										justifyContent : 'center',
										cursor         : 'default'
									}}
									onClick={(e) => e.stopPropagation()}
								>
									<MdInfoOutline fontSize='16px' />
								</Box>
							</Tooltip>}
						</MenuItem>
					)}

					{/* Share option */}
					{category?.allowShare && (
						<MenuItem onClick={handleCopyLink}>
							{language?.copylinkTxt}
						</MenuItem>
					)}
					{hasWritePermission && (
						<MenuItem onClick={(e) =>
						{
							setAnchorEl(null);
							handleEditCategory?.(e);
						}}
						>
							{language?.edit}
						</MenuItem>
					)}

					{hasWritePermission && (
						<MenuItem onClick={handleCategoryDelete}>
							{language?.delete}
						</MenuItem>
					)}
				</Menu>
			</Grid>
			{showDeleteConfirm && (
				<CategoryDeletePopup
					open={showDeleteConfirm}
					handleDialogClose={() => setShowDeleteConfirm(false)}
					categoryName={category?.name || ''}
					isConfirmed={isConfirmed}
					handleConfirmChange={handleConfirmChange}
					isDeleting={isDeleting}
					handleDelete={handleDeleteConfirm}
					subLabel={category?.contentCount.total > 0
						? 'All the content associated with this category will be moved to Uncategorized'
						: ''
					}
				/>
			)}
		</div>
	);
};
